import React from "react";
import styled from "styled-components";

function TableTabBlack({ style, list }) {
  return (
    <>
      <TableTabBlackWrapper style={{ ...style }}>
        {list.map((item, index) => {
          return (
            <Tab
              key={index}
              style={{}}
              onClick={() => {
                sessionStorage.setItem("tab", item);
              }}
            >
              {item.title}
            </Tab>
          );
        })}
      </TableTabBlackWrapper>
    </>
  );
}

export default TableTabBlack;

const TableTabBlackWrapper = styled.div.attrs((props) => {})`
  width: 924px;
  height: 35px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: 75px;
  padding: 7px 13px;
  border-radius: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  color: #fff;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  background-color: #262c31;
  cursor: pointer;
`;
